<template>
  <div class="modal-card" style="width: 960px; height: 800px">
    <header class="modal-card-head">
      <p class="modal-card-title">{{row['purchase_order__DOCUMENT__purchaseOrderID::zctFileNameContainer']}}</p>
    </header>
    <section class="modal-card-body">
      <object class="internal" :data="row['purchase_order__DOCUMENT__purchaseOrderID::document']"></object>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-outlined is-primary is-medium is-fullwidth" @click="$parent.close()">Cancel</button>
      <a class="button is-primary is-medium is-fullwidth" target="_blank" :href="row['purchase_order__DOCUMENT__purchaseOrderID::document']" download>Download</a>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'DocumentViewCard',
  props: ['row'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.object{
  display: block;
  max-width:230px;
  max-height:95px;
  width: auto;
  height: auto;
}

.internal {
    width: 100%;
    height: 603px;
    object-fit: scale-down; 
}
</style>




// WEBPACK FOOTER //
// src/pages/PurchaseOrder/DocumentViewCard.vue